module.exports = __webpack_public_path__ + "static/img/__4019.373fde2.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/__4019.jpg
// module id = 95Lj
// module chunks = 0